import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CvcFormButtonsComponent } from './form-buttons.component'

@NgModule({
  declarations: [CvcFormButtonsComponent],
  imports: [CommonModule],
  exports: [CvcFormButtonsComponent],
})
export class CvcFormButtonsModule {}
